import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/redux/reducers';
import AccountDropdown from '@/containers/AccountDropdown/AccountDropdown';

interface AuthDropdownProps {
  componentNotLoginYet: HTMLElement | React.ReactNode;
  textColor?: string;
  iconUser?: string;
}

const AuthDropdown: React.FC<AuthDropdownProps> = ({ componentNotLoginYet, textColor, iconUser }) => {
  const authUser = useSelector((state: RootState) => state.authUser.data);

  return authUser ? <AccountDropdown textColor={textColor} iconUser={iconUser} /> : <div>{componentNotLoginYet}</div>;
};

export default AuthDropdown;
